import axiosInstance from "../config/axios";
import API_ENDPOINTS from "../config/endpoints";

// Newsletter Service - Subscribe to newsletter
export const subscribeNewsletter = async (email) => {
  try {
    const payload = {
      email: email
    };
    
    const response = await axiosInstance.post(API_ENDPOINTS.SUBSCRIBE_NEWSLETTER, payload);
    return response;
  } catch (error) {
    throw error; // Centralized handler formats the error
  }
};

export default {
  subscribeNewsletter
};

